// extracted by mini-css-extract-plugin
export default {"fallbackContainer":"SuspenseWithFlag_fallbackContainer__Kl0vH","childrenContainer":"SuspenseWithFlag_childrenContainer__BFQNI"};